import React from "react";
import { imgSet } from "../lib/img";

// You can optionally extract these inline SVGs into a separate file if reused often
const Icons = {
  semester: (
    <svg className="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
      <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM5 8V6h14v2H5z" />
    </svg>
  ),
  professor: (
    <svg className="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 12c2.7 0 4.9-2.2 4.9-4.9S14.7 2.2 12 2.2 7.1 4.4 7.1 7.1 9.3 12 12 12zm0 2c-3 0-9 1.5-9 4.5V21h18v-2.5c0-3-6-4.5-9-4.5z" />
    </svg>
  ),
  tools: (
    <svg className="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
      <path d="M14.7 6.3L12.4 4 6.3 10.1l2.3 2.3-6 6V20h1.6l6-6 2.3 2.3L20 11.6l-5.3-5.3zM7.7 10.1L12.4 5.4l1.9 1.9-4.7 4.7-1.9-1.9zm9.4 1.3l-1.4 1.4-2.3-2.3 1.4-1.4 2.3 2.3z" />
    </svg>
  ),
  coAuthor: (
    <svg className="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
      <path d="M16 11c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.3 3 3 3zm-8 0c1.7 0 3-1.3 3-3S9.7 5 8 5 5 6.3 5 8s1.3 3 3 3zm0 2c-2.3 0-7 1.2-7 3.5V20h7v-2h2v2h7v-3.5c0-2.3-4.7-3.5-7-3.5zm8 0c-.3 0-.7 0-1 .1 1.2.9 2 2 2 3.4V20h4v-3.5c0-2.3-4.7-3.5-7-3.5z" />
    </svg>
  ),
};

const ProjectDescription = ({
  subtitle,
  description,
  secondDescription,
  thirdDescription,
  map,
  semester,
  professor,
  tools,
  coAuthor,
}) => {
  return (
    <section className="bg-gray-100 py-16 px-6">
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Left Column */}
        <div>
          <h2 className="text-2xl font-semibold text-gray-800">{subtitle}</h2>

          <div className="mt-4 space-y-2 text-gray-700 text-sm">
            <div className="flex items-center gap-2">
              {Icons.semester}
              <span>{semester}</span>
            </div>
            <div className="flex items-center gap-2">
              {Icons.professor}
              <span>{professor}</span>
            </div>
            <div className="flex items-center gap-2">
              {Icons.tools}
              <span>{tools}</span>
            </div>
            {coAuthor && (
              <div className="flex items-center gap-2">
                {Icons.coAuthor}
                <span>{coAuthor}</span>
              </div>
            )}
          </div>

          <img
            src={imgSet(map).mid}
            srcSet={imgSet(map).srcSet}
            sizes="(min-width: 768px) 50vw, 100vw"
            loading="lazy"
            decoding="async"
            alt="map"
            className="mt-6 w-full object-cover rounded-lg"
          />
        </div>

        {/* Right Column */}
        <div className="flex flex-col justify-center">
          <p className="text-gray-700 text-lg leading-relaxed">{description}</p>
          {secondDescription && (
            <p className="text-gray-700 text-lg leading-relaxed mt-4">
              {secondDescription}
            </p>
          )}
          {thirdDescription && (
            <p className="text-gray-700 text-lg leading-relaxed mt-4">
              {thirdDescription}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProjectDescription;
